import { ConversationMessageAvatar } from '@modules/feedback/components/ConversationMessageAvatar';
import { HighlightedFeedbackText } from '@modules/feedback/components/FeedbackHighlighter/HighlightedFeedbackText';
import { Highlight } from '@modules/feedback/types';
import { trackCopyFeedbackContentEvents } from '@modules/feedback/utils/trackCopyFeedbackContentEvents';
import { Paper, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Feedback } from 'v2/core/entities/feedback';
import { FeedbackContentConversation } from 'v2/core/entities/feedback/content';

interface ConversationTypeProps {
  feedback: Feedback;
  highlights: {
    [key: string]: Highlight[];
  };
  showOriginalLanguage: boolean;
}

export const ConversationType = ({
  feedback,
  highlights,
  showOriginalLanguage,
}: ConversationTypeProps) => {
  const conversation = showOriginalLanguage
    ? (feedback.content as FeedbackContentConversation).conversationOriginal
    : (feedback.content as FeedbackContentConversation).conversationEn;

  return (
    <Stack
      spacing={3}
      onCopy={() => {
        trackCopyFeedbackContentEvents({
          eventName: 'Copied Text From Feedback Content',
          feedbackID: feedback.id,
          feedbackType: feedback.content.type,
          contentType: 'raw',
        });
      }}
    >
      {conversation?.map((conversationUnit, index) => {
        const isUserActor = conversationUnit.actor === 'User';

        const shouldAlignToRight = isUserActor;

        return (
          <Box key={index} width="100%">
            <Stack direction="row" width="100%">
              <Stack
                direction={shouldAlignToRight ? 'row' : 'row-reverse'}
                columnGap={1}
                width="100%"
              >
                <ConversationMessageAvatar actor={conversationUnit.actor} />
                <Paper
                  sx={{
                    padding: 3,
                    borderRadius: 4,
                    borderTopRightRadius: !shouldAlignToRight ? 1 : 16,
                    borderTopLeftRadius: !shouldAlignToRight ? 16 : 1,
                    width: '70%',
                    backgroundColor: isUserActor
                      ? 'feedback.chatBubble.primary'
                      : 'feedback.chatBubble.secondary',
                    boxShadow: 'none',
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      wordBreak: 'break-word',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    <HighlightedFeedbackText
                      text={conversationUnit.text}
                      highlights={highlights[index]}
                      msgIndex={index}
                      showOriginalLanguage={showOriginalLanguage}
                    />
                  </Typography>
                </Paper>
              </Stack>
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
};
